// Indian classical taals.
// Each taal: name, matras (total beats), vibhag (groupings),
// beats: [{ bol, type }] where type is 'sam' | 'tali' | 'khali' | null.

export const TAALS = [
    {
        id: "teentaal",
        name: "Teentaal",
        matras: 16,
        vibhag: [4, 4, 4, 4],
        description: "The most popular taal in Hindustani music. 16 beats.",
        beats: [
            { bol: "Dha", type: "sam" },
            { bol: "Dhin", type: null },
            { bol: "Dhin", type: null },
            { bol: "Dha", type: null },
            { bol: "Dha", type: "tali" },
            { bol: "Dhin", type: null },
            { bol: "Dhin", type: null },
            { bol: "Dha", type: null },
            { bol: "Dha", type: "khali" },
            { bol: "Tin", type: null },
            { bol: "Tin", type: null },
            { bol: "Ta", type: null },
            { bol: "Ta", type: "tali" },
            { bol: "Dhin", type: null },
            { bol: "Dhin", type: null },
            { bol: "Dha", type: null },
        ],
    },
    {
        id: "ektaal",
        name: "Ektaal",
        matras: 12,
        vibhag: [2, 2, 2, 2, 2, 2],
        description: "12 beats, common in vilambit khayal and instrumentals.",
        beats: [
            { bol: "Dhin", type: "sam" },
            { bol: "Dhin", type: null },
            { bol: "Dhage", type: "khali" },
            { bol: "Tirkit", type: null },
            { bol: "Tu", type: "tali" },
            { bol: "Na", type: null },
            { bol: "Kat", type: "khali" },
            { bol: "Ta", type: null },
            { bol: "Dhage", type: "tali" },
            { bol: "Tirkit", type: null },
            { bol: "Dhi", type: "tali" },
            { bol: "Na", type: null },
        ],
    },
    {
        id: "jhaptaal",
        name: "Jhaptaal",
        matras: 10,
        vibhag: [2, 3, 2, 3],
        description: "10 beats, used in khayal and instrumental music.",
        beats: [
            { bol: "Dhi", type: "sam" },
            { bol: "Na", type: null },
            { bol: "Dhi", type: "tali" },
            { bol: "Dhi", type: null },
            { bol: "Na", type: null },
            { bol: "Ti", type: "khali" },
            { bol: "Na", type: null },
            { bol: "Dhi", type: "tali" },
            { bol: "Dhi", type: null },
            { bol: "Na", type: null },
        ],
    },
    {
        id: "rupak",
        name: "Rupak",
        matras: 7,
        vibhag: [3, 2, 2],
        description: "7 beats, starts on khali (no clap on sam).",
        beats: [
            { bol: "Tin", type: "khali" },
            { bol: "Tin", type: null },
            { bol: "Na", type: null },
            { bol: "Dhin", type: "tali" },
            { bol: "Na", type: null },
            { bol: "Dhin", type: "tali" },
            { bol: "Na", type: null },
        ],
    },
    {
        id: "dadra",
        name: "Dadra",
        matras: 6,
        vibhag: [3, 3],
        description: "6 beats, light classical and semi-classical.",
        beats: [
            { bol: "Dha", type: "sam" },
            { bol: "Dhin", type: null },
            { bol: "Na", type: null },
            { bol: "Dha", type: "khali" },
            { bol: "Tin", type: null },
            { bol: "Na", type: null },
        ],
    },
    {
        id: "kaharwa",
        name: "Kaharwa",
        matras: 8,
        vibhag: [4, 4],
        description: "8 beats, the most popular folk/bhajan taal.",
        beats: [
            { bol: "Dha", type: "sam" },
            { bol: "Ge", type: null },
            { bol: "Na", type: null },
            { bol: "Ti", type: null },
            { bol: "Na", type: "khali" },
            { bol: "Ka", type: null },
            { bol: "Dhin", type: null },
            { bol: "Na", type: null },
        ],
    },
    {
        id: "bhajani",
        name: "Bhajani",
        matras: 8,
        vibhag: [4, 4],
        description: "8 beats, bhajan-oriented variant of kaharwa.",
        beats: [
            { bol: "Dhin", type: "sam" },
            { bol: "Na", type: null },
            { bol: "Dhin", type: null },
            { bol: "Dhin", type: null },
            { bol: "Na", type: "khali" },
            { bol: "Tin", type: null },
            { bol: "Na", type: null },
            { bol: "Na", type: null },
        ],
    },
    {
        id: "deepchandi",
        name: "Deepchandi",
        matras: 14,
        vibhag: [3, 4, 3, 4],
        description: "14 beats, romantic taal of thumri and ghazal.",
        beats: [
            { bol: "Dha", type: "sam" },
            { bol: "Dhin", type: null },
            { bol: "—", type: null },
            { bol: "Dha", type: "tali" },
            { bol: "Dha", type: null },
            { bol: "Tin", type: null },
            { bol: "—", type: null },
            { bol: "Ta", type: "khali" },
            { bol: "Tin", type: null },
            { bol: "—", type: null },
            { bol: "Dha", type: "tali" },
            { bol: "Dha", type: null },
            { bol: "Dhin", type: null },
            { bol: "—", type: null },
        ],
    },
    {
        id: "tilwada",
        name: "Tilwada",
        matras: 16,
        vibhag: [4, 4, 4, 4],
        description: "16 beats, slower variant used in vilambit khayal.",
        beats: [
            { bol: "Dha", type: "sam" },
            { bol: "Trkt", type: null },
            { bol: "Dhin", type: null },
            { bol: "Dhin", type: null },
            { bol: "Dha", type: "tali" },
            { bol: "Dha", type: null },
            { bol: "Tin", type: null },
            { bol: "Tin", type: null },
            { bol: "Ta", type: "khali" },
            { bol: "Trkt", type: null },
            { bol: "Dhin", type: null },
            { bol: "Dhin", type: null },
            { bol: "Dha", type: "tali" },
            { bol: "Dha", type: null },
            { bol: "Dhin", type: null },
            { bol: "Dhin", type: null },
        ],
    },
    {
        id: "chautaal",
        name: "Chautaal",
        matras: 12,
        vibhag: [2, 2, 2, 2, 2, 2],
        description: "12 beats, used in dhrupad/dhamar tradition.",
        beats: [
            { bol: "Dha", type: "sam" },
            { bol: "Dha", type: null },
            { bol: "Dhin", type: "tali" },
            { bol: "Ta", type: null },
            { bol: "Kita", type: "tali" },
            { bol: "Dha", type: null },
            { bol: "Dhin", type: "khali" },
            { bol: "Ta", type: null },
            { bol: "Tita", type: "khali" },
            { bol: "Kata", type: null },
            { bol: "Gadi", type: "tali" },
            { bol: "Gana", type: null },
        ],
    },
    {
        id: "adachautaal",
        name: "Ada Chautaal",
        matras: 14,
        vibhag: [2, 4, 4, 4],
        description: "14 beats, classical taal of khayal.",
        beats: [
            { bol: "Dhin", type: "sam" },
            { bol: "Trkt", type: null },
            { bol: "Dhin", type: "tali" },
            { bol: "Na", type: null },
            { bol: "Tu", type: null },
            { bol: "Na", type: null },
            { bol: "Kat", type: "khali" },
            { bol: "Ta", type: null },
            { bol: "Trkt", type: null },
            { bol: "Dhin", type: null },
            { bol: "Dhin", type: "tali" },
            { bol: "Na", type: null },
            { bol: "Dhin", type: null },
            { bol: "Na", type: null },
        ],
    },
    {
        id: "dhamar",
        name: "Dhamar",
        matras: 14,
        vibhag: [5, 2, 3, 4],
        description: "14 beats, the signature taal of the Dhamar tradition.",
        beats: [
            { bol: "Ka", type: "sam" },
            { bol: "Dhi", type: null },
            { bol: "Ta", type: null },
            { bol: "Dhi", type: null },
            { bol: "Ta", type: null },
            { bol: "Dha", type: "tali" },
            { bol: "—", type: null },
            { bol: "Ga", type: "khali" },
            { bol: "Ti", type: null },
            { bol: "Na", type: null },
            { bol: "Di", type: "tali" },
            { bol: "Na", type: null },
            { bol: "Dhi", type: null },
            { bol: "Na", type: null },
        ],
    },
    {
        id: "sultaal",
        name: "Sul Taal",
        matras: 10,
        vibhag: [2, 2, 2, 2, 2],
        description: "10 beats, dhrupad tradition.",
        beats: [
            { bol: "Dha", type: "sam" },
            { bol: "Dha", type: null },
            { bol: "Dhin", type: "khali" },
            { bol: "Ta", type: null },
            { bol: "Kita", type: "tali" },
            { bol: "Dha", type: null },
            { bol: "Tita", type: "khali" },
            { bol: "Kata", type: null },
            { bol: "Gadi", type: "tali" },
            { bol: "Gana", type: null },
        ],
    },
];

export const getTaal = (id) => TAALS.find((t) => t.id === id) || TAALS[0];
